import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import indsac_crm from "../Images/indsac-crm.gif";
import { Link } from "react-router-dom";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";

export default function Resources() {
  return (
    <>
      <SEO
        title="CRM & ERP Knowledge Base & Guides"
        description="Explore EnteliPro's comprehensive guide on Customer Relationship Management and AI ERP solutions. Learn how to choose the right CRM and scale your business."
        keywords="What is CRM, CRM Benefits, AI ERP Solutions for Small Business, Choosing Right CRM, Customer Relationship Management Guide, Cloud ERP Resources"
        canonical="https://www.entelipro.com/resources"
        ogImage="https://www.entelipro.com/static/media/indsac-crm.gif"
      />

      <Navbar />
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Resources</li>
            </ul>
          </div>
        </div>
      </section>
      {/* breadcrumbs  */}
      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={indsac_crm}
                  alt="EnteliPro CRM and AI ERP Solutions Architecture"
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <style>{`
                  .crm-intro-header {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 10px;
                  }
                  .crm-intro-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    background: rgba(123,85,255,0.1);
                    border: 1px solid rgba(123,85,255,0.3);
                    color: #7b55ff;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0.8px;
                    padding: 4px 12px;
                    border-radius: 50px;
                    text-transform: uppercase;
                    animation: badgePop 0.4s ease both;
                  }
                  @keyframes badgePop {
                    from { opacity: 0; transform: scale(0.85); }
                    to   { opacity: 1; transform: scale(1); }
                  }
                  .crm-intro-heading {
                    font-size: 26px;
                    font-weight: 800;
                    color: #1e293b;
                    letter-spacing: -0.4px;
                    margin-bottom: 4px;
                    position: relative;
                    display: inline-block;
                  }
                  .crm-intro-heading::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: -4px;
                    width: 0;
                    height: 3px;
                    background: linear-gradient(90deg, #7b55ff, #38bdf8);
                    border-radius: 4px;
                    animation: underlineGrow 0.8s 0.3s cubic-bezier(0.4,0,0.2,1) both;
                  }
                  @keyframes underlineGrow {
                    from { width: 0; }
                    to   { width: 100%; }
                  }
                  .crm-para-card {
                    background: #f8fafc;
                    border-left: 3px solid #7b55ff;
                    border-radius: 0 10px 10px 0;
                    padding: 12px 16px;
                    margin-top: 14px;
                    font-size: 14.5px;
                    line-height: 1.72;
                    color: #475569;
                    display: flex;
                    gap: 12px;
                    align-items: flex-start;
                    animation: slideInLeft 0.5s ease both;
                  }
                  .crm-para-card:nth-of-type(2) { animation-delay: 0.1s; }
                  .crm-para-card:nth-of-type(3) { animation-delay: 0.2s; }
                  @keyframes slideInLeft {
                    from { opacity: 0; transform: translateX(-12px); }
                    to   { opacity: 1; transform: translateX(0); }
                  }
                  .crm-para-icon {
                    font-size: 18px;
                    flex-shrink: 0;
                    margin-top: 2px;
                  }
                  .crm-metric-strip {
                    display: flex;
                    gap: 16px;
                    flex-wrap: wrap;
                    margin-top: 18px;
                  }
                  .crm-metric-chip {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    background: #fff;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 10px 18px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                    transition: all 0.25s ease;
                    animation: chipIn 0.5s ease both;
                    min-width: 80px;
                  }
                  .crm-metric-chip:nth-child(1) { animation-delay: 0.3s; }
                  .crm-metric-chip:nth-child(2) { animation-delay: 0.4s; }
                  .crm-metric-chip:nth-child(3) { animation-delay: 0.5s; }
                  .crm-metric-chip:hover {
                    border-color: #7b55ff;
                    box-shadow: 0 4px 14px rgba(123,85,255,0.15);
                    transform: translateY(-3px);
                  }
                  @keyframes chipIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to   { opacity: 1; transform: translateY(0); }
                  }
                  .crm-metric-num {
                    font-size: 20px;
                    font-weight: 800;
                    color: #7b55ff;
                    line-height: 1;
                  }
                  .crm-metric-lbl {
                    font-size: 10.5px;
                    color: #64748b;
                    font-weight: 600;
                    margin-top: 3px;
                    text-align: center;
                  }
                `}</style>

                <div className="crm-intro-badge">📚 Overview
                </div>
                <h4 className="crm-intro-heading" style={{ marginTop: "10px" }}>What is CRM?</h4>

                <div className="crm-para-card">
                  <span className="crm-para-icon">🤝</span>
                  <span>
                    CRM (Customer Relationship Management), in its simplest form,
                    helps companies build and improve lead and customer
                    relationships and improve the efficiency of customer-facing
                    processes.
                  </span>
                </div>
                <div className="crm-para-card">
                  <span className="crm-para-icon">🎯</span>
                  <span>
                    It is the strategy to identify, understand, manage, and
                    cater to the business needs of their prospects and
                    existing customers.
                  </span>
                </div>
                <div className="crm-para-card">
                  <span className="crm-para-icon">🚀</span>
                  <span>
                    CRM software was originally designed to help businesses
                    build and maintain relationships with new and existing
                    customers. Since then, CRM software has evolved from a
                    simple contact management system into a robust tool that
                    helps users manage sales, marketing, point-of-sale (POS)
                    transactions, accounting, vendors, and other types of
                    operational data all in one easily accessible solution.
                  </span>
                </div>

                {/* Animated Metric Chips */}
                <div className="crm-metric-strip">
                  <div className="crm-metric-chip">
                    <span className="crm-metric-num">41%</span>
                    <span className="crm-metric-lbl">More Revenue</span>
                  </div>
                  <div className="crm-metric-chip">
                    <span className="crm-metric-num">300%</span>
                    <span className="crm-metric-lbl">Lead Conversion</span>
                  </div>
                  <div className="crm-metric-chip">
                    <span className="crm-metric-num">27%</span>
                    <span className="crm-metric-lbl">Better Retention</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <style>{`
                .crm-why-section {
                  padding-top: 10px;
                }
                .crm-why-heading {
                  font-size: 22px;
                  font-weight: 800;
                  color: #1e293b;
                  margin-bottom: 14px;
                  display: flex;
                  align-items: center;
                  gap: 10px;
                }
                .crm-why-heading span.why-icon {
                  font-size: 24px;
                }
                .crm-why-card {
                  background: #fff;
                  border: 1px solid #e8edf3;
                  border-radius: 12px;
                  padding: 14px 18px;
                  margin-bottom: 10px;
                  display: flex;
                  gap: 12px;
                  align-items: flex-start;
                  font-size: 14.5px;
                  line-height: 1.72;
                  color: #475569;
                  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
                  transition: all 0.25s ease;
                  animation: whySlideIn 0.5s ease both;
                }
                .crm-why-card:hover {
                  border-color: #7b55ff;
                  box-shadow: 0 4px 16px rgba(123,85,255,0.1);
                  transform: translateX(4px);
                }
                .crm-why-card:nth-child(2) { animation-delay: 0.1s; }
                @keyframes whySlideIn {
                  from { opacity: 0; transform: translateY(10px); }
                  to   { opacity: 1; transform: translateY(0); }
                }
                .crm-why-card-icon {
                  font-size: 20px;
                  flex-shrink: 0;
                  margin-top: 2px;
                }
              `}</style>
              <h3 className="crm-why-heading"><span className="why-icon">❓</span> Why do businesses need a CRM?</h3>
              <div className="crm-why-card">
                <span className="crm-why-card-icon">📋</span>
                <span>
                  Customer relationship management is any tool, strategy, or
                  process that helps businesses better organize and access
                  customer data. It all started with handwritten notes but with
                  the advent and proliferation of digital technology, it
                  eventually evolved into databases stored on individual
                  computers, and then the CRM definition shifted into something
                  far more complex.
                </span>
              </div>
              <div className="crm-why-card">
                <span className="crm-why-card-icon">🏆</span>
                <span>
                  It was no longer just notes. Managing your business
                  relationships with customers became a complicated process. Now,
                  to compete in any industry, you need a reliable system built on
                  CRM software. Managing every aspect of the business can be made
                  easier with a robust CRM system. It should readily understand
                  the business, unite it with the employees and customers alike
                  and capture the business information such that one gets a
                  holistic view of each customer in real-time.
                </span>
              </div>
            </div>
            <div className="left-text">
              <h3>Benefits of {`${project_name}`}</h3>
            </div>
            <div className="row about-about">
              <div className="col-lg-4 col-md-6">
                <div className="about-grids">
                  <h4>Enhances Better Customer Service</h4>
                  <p className="para">
                    This system allows each employee to understand the specific
                    needs of their customers as well as their transaction
                    file.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Helps the sales team in closing deals faster</h4>
                  <p className="para">
                    A CRM system helps in closing faster deals by facilitating
                    quicker and more efficient responses to customer leads and
                    information.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Facilitates optimized marketing</h4>
                  <p className="para">
                    CRM enables a business to understand the needs and behavior
                    of its customers. This allows them to identify the correct
                    time to market their products to customers.
                  </p>
                  <div className="mt-3 about-list"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CRM Overview & Choice Guide Section */}
      <section className="crm-guide-section">
        <style>{`
          .crm-guide-section {
            padding: 60px 0 80px 0;
            background-color: #f8fafc;
          }
          .crm-guide-card {
            background: #ffffff;
            border: 1px solid #e2e8f0;
            border-radius: 16px;
            padding: 36px 40px;
            margin-bottom: 28px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
            transition: all 0.3s ease;
          }
          .crm-guide-card:hover {
            border-color: #cbd5e1;
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
          }
          .crm-guide-card h3 {
            font-size: 24px;
            font-weight: 700;
            color: #1e293b;
            margin-bottom: 16px;
            letter-spacing: -0.3px;
          }
          .crm-guide-card p {
            font-size: 15.5px;
            line-height: 1.75;
            color: #475569;
            margin-bottom: 14px;
          }
          .crm-guide-card p:last-child {
            margin-bottom: 0;
          }
          .crm-guide-action {
            margin-top: 24px;
          }
          .crm-guide-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            background: #7b55ff;
            color: #ffffff !important;
            border: none;
            padding: 12px 32px;
            font-size: 15px;
            font-weight: 600;
            border-radius: 50px;
            box-shadow: 0 4px 14px rgba(123, 85, 255, 0.25);
            transition: all 0.25s ease;
            text-decoration: none;
          }
          .crm-guide-btn:hover {
            background: #673ee6;
            color: #ffffff !important;
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(123, 85, 255, 0.35);
          }
          @media (max-width: 768px) {
            .crm-guide-card {
              padding: 24px 20px;
              margin-bottom: 20px;
            }
            .crm-guide-card h3 {
              font-size: 20px;
            }
            .crm-guide-card p {
              font-size: 14.5px;
            }
          }
        `}</style>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {/* Card 1: Why CRM is necessary */}
              <div className="crm-guide-card">
                <h3>CRM system is really necessary for business</h3>
                <p>
                  CRM helps businesses build a relationship with their customers
                  that, in turn, creates loyalty and customer retention. Since
                  customer loyalty and revenue are both qualities that affect a
                  company's revenue, CRM is a management strategy that results in
                  increased profits for a business. At its core, a CRM tool
                  creates a simple user interface for a collection of data that
                  helps businesses recognize and communicate with customers in a
                  scalable way. Small businesses and even freelancers can benefit
                  from CRM processes as well.
                </p>
              </div>

              {/* Card 2: How to choose the best CRM */}
              <div className="crm-guide-card">
                <h3>How to choose the best CRM</h3>
                <p>
                  Choosing the right CRM for your business isn't easy.
                </p>
                <p>
                  The difficulty lies not only in the fact that there are many
                  solutions and technologies to choose from. But you also have to
                  consider deployment options, ability to customize, cost,
                  scalability, and business value, before you decide.
                </p>
                <p>
                  With so many things to consider when choosing a CRM for your
                  business, there is another important thing that your own needs.
                </p>
                <div className="crm-guide-action">
                  <Link to="/choosingrightcrm" className="crm-guide-btn">
                    Read more &rarr;
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
